const setLangToBodyClass = function(lang) {
    const body = document.body;
    body.className += body.className === '' ? `${lang}` : ` ${lang}`;
};

export { setLangToBodyClass };
